import { render } from "./AddCreance.vue?vue&type=template&id=4ae983a0&scoped=true&ts=true"
import script from "./AddCreance.vue?vue&type=script&lang=ts"
export * from "./AddCreance.vue?vue&type=script&lang=ts"

import "./AddCreance.vue?vue&type=style&index=0&id=4ae983a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae983a0"]])

export default __exports__